import { ZonalGrossMarginCreationForm } from "../create/schema/zonal-gross-margin-creation.schema";
import { formatCurrencyInputToNumber } from "@/utils/query-string";

export const hasEmptyZonalGrossMarginFormValues = (
  values?: Partial<ZonalGrossMarginCreationForm>,
) => {
  if (!values) return true;

  const numericFields: (keyof ZonalGrossMarginCreationForm)[] = [
    "cotizacionDolar",
    "precioCereal",
    "rindeEstimadoZonal",
    "precioAgroquimicos",
    "precioFertilizantes",
    "precioSemillas",
    "precioLabores",
    "precioSeguros",
    "gastoDeCosecha",
    "inversionTotal",
    "equilibrio",
  ];

  const arrayFields: (keyof ZonalGrossMarginCreationForm)[] = [
    "idZonaProductiva",
    "idGranoProductivo",
    "idCampanaProductiva",
  ];

  for (const field of arrayFields) {
    const value = values[field];
    if (Array.isArray(value) && value.length === 0) return true;
  }

  for (const field of numericFields) {
    const value = values[field];
    const numValue = formatCurrencyInputToNumber(value ?? 0);
    if (numValue === 0) return true;
  }

  return false;
};
